import dayjs from 'dayjs';
import { memo } from 'react';
import { LogoMobile } from 'src/config/components/LogoMobile';

const SEPARATOR_STYLES = 'w-full border-t-1 border-f_separator flex-1';

const _FooterCopyrightBlock = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center my-10 gap-2.5">
      <div className="w-full flex justify-center items-center">
        <div className={SEPARATOR_STYLES} />
        <LogoMobile className="w-10 mx-2" />
        <div className={SEPARATOR_STYLES} />
      </div>
      <p className="text-[8px] text-fcb_text">{`All rights reserved ${dayjs().year()}`}</p>
    </div>
  );
};

export const FooterCopyrightBlock = memo(_FooterCopyrightBlock);
